import { Component, OnInit, Optional, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-vquadbtfxo',
  templateUrl: './vquadbtfxo.component.html',
  styleUrls: ['./vquadbtfxo.component.scss']
})
export class VquadbtfxoComponent implements OnInit {
  fromPage: string[];
  nodeStatus: boolean = false;
  title: string;
  baseUrl: string;
  url: string;
  BtName1: string;
  BtNum1: string;
  BtName2: string;
  BtNum2: string;
  BtName3: string;
  BtNum3: string;
  BtName4: string;
  BtNum4: string;
  BtName5: string;
  BtNum5: string;
  BtName6: string;
  BtNum6: string;
  BtName7: string;
  BtNum7: string;
  BtName8: string;
  BtNum8: string;
  BtName9: string;
  BtNum9: string;
  BtName10: string;
  BtNum10: string;
  BtName11: string;
  BtNum11: string;
  BtName12: string;
  BtNum12: string;

  @Output() childTitleEvent = new EventEmitter<string>();

  constructor(private http: HttpClient, public dialogBox: MatDialogRef<VquadbtfxoComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.baseUrl = environment.urlAddress + '/api/';

    //let rows: any[] = JSON.parse(data.pageValue) as any[];
    this.fromPage = data.pageValue;//Node ID
    this.nodeStatus = data.nodeStatus;
    //console.log(data.nodeStatus);

    this.BindBTFXO(data.pageValue);

  }

  ngOnInit() {


    //let arr = [10, 20, 30, 40];

    //for (var val of this.fromPage) {
    //  console.log(val); // prints values: 10, 20, 30, 40
    //}
  }
  Close() {
    this.dialogBox.close();
  }
  btfxoData: any[] = [];
  successMsg: boolean = false;
  BindBTFXO(nodeID: number) {
    this.successMsg = false;
    this.GetBTFXO(nodeID).subscribe((res: any) => {
      // console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
     //debugger;
      //console.log(rows);
      this.btfxoData = rows;
      //for (var obj of rows) {
      //  this.BtName1 = obj.BTName_Abs;

      //}

    });
  }
  UpdateBTFxo() {
    for (const key in this.btfxoData) {
      if (this.btfxoData[key]) {
        this.btfxoData[key].NodeID_Abs = this.fromPage;
      }
    }
    //console.log(this.btfxoData)
    this.UpdateVquadBTFxoData(this.btfxoData).subscribe((res: any) => {
      this.successMsg = true;
    });
  }

  parentEvent(title) {
    //debugger;

    this.title = title;
    this.childTitleEvent.emit(this.title);
  }

  GetBTFXO(nodeID: number) {

    this.url = environment.urlAddress + '/api/' + 'NwStat_VQuad/GetBtFxosByNodeID_New?nodeID=' + nodeID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });

  }

  UpdateVquadBTFxoData(btfxoData : any) {
    this.url = this.baseUrl + 'NwStat_VQuad/UpdateNwStat_VquadBTFxo';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, btfxoData, options);
  }

}
